import { throwError } from 'rxjs';
import { PlannedError } from '../error/planned-error';

export const selectErrorHandler = (handlers: Record<string, unknown>, error: unknown, useDefault: boolean = true): unknown => {
  const handlerIds = Object.keys(handlers);
  if (error instanceof PlannedError && handlerIds.includes(error.errorType)) {
    return handlers[error.errorType];
  } else if (useDefault && handlerIds.includes('DEFAULT')) {
    return handlers['DEFAULT'];
  } else {
    return () => throwError(() => error);
  }
};
